export const siteAPIDomain = 'http://dev1.1800accountant.com';
export const WordPressAPIURL = 'https://staging1800a.wpengine.com/wp-json/';
export const SiteAPIURL = `${siteAPIDomain}/cbapi/app.php/`;
